/**
 * Route definition for /explore2
 * Renders the Explore2Container component.
 *
 * @module routes/explore2
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import Explore2Container from '@/containers/Explore2'

export const Route = createFileRoute('/$locale/explore2')({
  component: Explore2,
})

/**
 * Explore2 page component.
 * Renders the Explore2 container for alternative explore view.
 *
 * @returns {React.ReactElement}
 */
function Explore2() {
  return (
    <>
      <Explore2Container />
    </>
  )
}